import type { RouteRecordRaw } from "vue-router";
const onError = (err: any) => {
  console.error("Failed to load async component: ", err);
  throw new Error(err);
};

const System: RouteRecordRaw = {
  name: "系统设置",
  path: "/system",
  component: () => import("@/components/Layout/index.vue").catch(onError),
  redirect: "/system/menu-manage",
  meta: {
    key: "/system"
  },
  children: [
    {
      name: "菜单管理",
      path: "menu-manage",
      meta: {
        key: "/system/menu-manage"
      },
      component: () =>
        import("@/views/System/MenuManage/index.vue").catch(onError)
    },
    {
      name: "角色管理",
      path: "role-manage",
      meta: {
        key: "/system/role-manage"
      },
      component: () =>
        import("@/views/System/RoleManage/index.vue").catch(onError)
    },
    {
      name: "用户管理",
      path: "user-manage",
      meta: {
        key: "/system/user-manage"
      },
      component: () =>
        import("@/views/System/UserManage/index.vue").catch(onError)
    },
    {
      name: "部门管理",
      path: "department-manage",
      meta: {
        key: "/system/department-manage"
      },
      component: () =>
        import("@/views/System/DeptManage/index.vue").catch(onError)
    },
    {
      name: "数据权限",
      path: "data-scope",
      meta: {
        key: "/system/data-scope"
      },
      component: () =>
        import("@/views/System/DataScope/index.vue").catch(onError)
    },
    {
      name: "接口权限",
      path: "api-scope",
      meta: {
        key: "/system/api-scope"
      },
      component: () =>
        import("@/views/System/ApiScope/index.vue").catch(onError)
    },
    {
      name: "参数管理",
      path: "param-manage",
      meta: {
        key: "/system/param-manage"
      },
      component: () =>
        import("@/views/System/ParamManage/index.vue").catch(onError)
    },
    {
      name: "字典管理",
      path: "dict-manage",
      meta: {
        key: "/system/dict-manage"
      },
      component: () =>
        import("@/views/System/DictManage/index.vue").catch(onError)
    },
    {
      name: "反馈管理",
      path: "feedback-manage",
      meta: {
        key: "/system/feedback-manage"
      },
      component: () =>
        import("@/views/System/Feedback/index.vue").catch(onError)
    }
  ]
};

export default System;
